import gsap, { SplitText } from "@lib/gsap";
import { onMount, onView, onTrack, onDestroy, onPageIn, onPageOut } from "./_";
import { ref, watch } from "@vue/reactivity";

export default function (element, dataset) {
  const currentTab = ref(1);

  const cards = element.querySelectorAll(".cst_cards_item");
  const links = element.querySelectorAll(".cst_tabs_item");

  links.forEach((e, i) => {
    e.addEventListener("click", () => {
      currentTab.value = i;
    });
  });

  watch(currentTab, (newVal, oldVal) => {
    const notNewTab = Array.from(cards).filter((card, index) => {
      return index !== newVal;
    });
    let tl = gsap.timeline();

    tl.to(notNewTab, {
      opacity: 0,
    });

    tl.to(
      cards[newVal],
      {
        opacity: 1,
      },
      "<",
    );

    tl.to(
      links[newVal],
      {
        backgroundColor: "#F1DAFE",
      },
      "<",
    );

    tl.to(
      links[oldVal],
      {
        backgroundColor: "rgba(241, 218, 254, 0)",
      },
      "<",
    );
  });

  currentTab.value = 0;
}
